const INITIAL_STATE = {
  jobsList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_JOBS': {
      return { ...state, jobsList: action.jobs };
    }
    default:
      return state;
  }
};
